<p-drawer (onHide)="drawer?.onHide && drawer?.onHide()" [style]="{ width: drawer?.width || '25vw' }"
  [ngClass]="classes().container" [position]="drawer?.position || 'right'" [closeOnEscape]="!!drawer?.closeOnEscape"
  [dismissible]="!!drawer?.dismissable" [(visible)]="visible" (visibleChange)="visibleChange.emit($event)">
  <ng-template #header>
    <div [ngClass]="['flex flex-col gap-2', classes().header]">
      <span class="font-bold text-2xl block">{{ title() | translate }}</span>
      <span class="opacity-70">{{ description() | translate }}</span>
    </div>
  </ng-template>

  <div [ngClass]="['flex flex-col h-full', classes().body]">
    <div class="flex-1 overflow-auto">
      <ng-container *ngIf="drawer?.component" [ngComponentOutlet]="drawer?.component?.outlet"
        [ngComponentOutletInputs]="drawer?.component?.props"></ng-container>
    </div>

    <div [ngClass]="['flex justify-end gap-2 p-4 border-t dark:border-zinc-700', classes().footer]">
      <ng-container *ngFor="let action of drawer?.actions">
        <p-button [label]="action.label | translate" [severity]="action.variant || 'primary'" (click)="action.onClick()"
          [disabled]="action.disabled | async"></p-button>
      </ng-container>
    </div>
  </div>
</p-drawer>